export const locale = {
  lang: "en-CA",
  data: {
    ORDER_PRODUCTS: {
      TITLE: "Add products",
      TITLE_CREATE: "Add products",
      LEFT_LIST_LABEL: "Drag & drop or use the + button to add product",
      RIGHT_LIST_LABEL: "List of products to add",
      CREATE_PRODUCT: "Create product",
      SEARCH: "search by internal name, external name or product code",
      SEARCH_PRODUCT: "Perform a search for your product.",
      CATEGORY_FILTER: "Product category",
      TAGS_FILTER: "Tags",
      NO_SEARCH_RESULTS_LINE1: "No results for your search.",
      NO_SEARCH_RESULTS_LINE2: "Please try something else.",
      GROUP_NAME: "Selection name",
      CHOICE_REQUIRED_NO_SKIP: "Choice required",
      UPSALE_TITLE: "Add upsell products",
      ORIGINAL_PRICE: "Original price",
      NEW_PRICE: "New price",
    },
  },
};
